export * from './SuperHeroTertiaryCardFeature';
